// Client side of the api's on-demand image resizer (aldoo-na/image-variants):
// any static mount that runs it answers `<url>?size=<width>` with a variant
// generated once and kept on disk. Requests snap UP to the server's bucket
// list, so only these widths make distinct files — this list is the subset of
// the server's WIDTH_BUCKETS worth offering in a srcset.
export const IMAGE_VARIANT_WIDTHS = [320, 480, 640, 768, 960, 1280, 1600]

// Formats the resizer can scale; anything else (svg, gif) is served as is.
const RESIZABLE = /\.(png|jpe?g|webp|avif)$/i

/** True for a url the resizer can answer with a variant. */
export const isResizable = (url) =>
  typeof url === "string" && RESIZABLE.test(url.split("?")[0]) && !url.includes("?")

/** The url of one variant; non-resizable urls come back unchanged. */
export const sizedUrl = (url, width) => (isResizable(url) ? `${url}?size=${width}` : url)

/**
 * srcset over the variant widths: "<url>?size=320 320w, <url>?size=480 480w, …"
 * ("" when the url cannot be resized). Pair it with a `sizes` attribute.
 */
export const srcsetFor = (url, widths = IMAGE_VARIANT_WIDTHS) =>
  isResizable(url) ? widths.map((w) => `${url}?size=${w} ${w}w`).join(", ") : ""
